var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M30.2 43.2c-1-0.9-2.6-0.9-3.6 0l-8.5 8.2 0-49c0-1.4-1.2-2.5-2.6-2.5 -1.4 0-2.6 1.1-2.6 2.5l0 49 -8.5-8.2c-1-1-2.7-0.9-3.7 0.1 -1 1-1 2.5 0 3.5l12.9 12.5c1 1 2.6 1 3.7 0 0 0 0 0 0 0l12.9-12.5c1-1 1-2.6-0.1-3.5Z"}));
}

ArrowDown.defaultProps = {"width":"31","height":"60","viewBox":"0 0 31 60","strokeLinejoin":"round"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
